import styled from 'styled-components'

export const FormWrapper = styled.div`
  overflow-y: auto;
  height: 370px;
  padding: 0 1rem;
`
